export const ANDROID = 'android';
export const IOS = 'ios';
export const MWEB = 'mweb';
export const DWEB = 'dweb';
export const MOBILE_REG_EXP = /mobile|phone|ipad|mini|tablet/i;
export const ANDROID_REG_EXP = /nykaa-android/i;
export const IOS_REG_EXP = /nykaa-ios/i;
